<template>
    <div class="group">
        <div class="page-group-title"><span>基本信息</span></div>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="poster" label="预览图:" :rules='[{required: true, message: "请上传商品预览图"}]' :show-message="!formData.poster">
                    <image-upload 
                        :url.sync="formData.poster" 
                        :urlFull.sync="formData.poster" 
                        :original.sync="formData.posterOriginal"
                        :crop="true"
                        :width="1200"
                        :height="1200"
                        ref="posterUpload"
                        class="poster-upload"
                        @onSuccess="handlePosterSuccess"
                    >
                    </image-upload>
                    <div v-if="formData.id">
                        <el-button v-if="$utils.have('/activity/addSoldOut')" icon="el-icon-collection-tag" size="mini" @click="addSoldOut" :loading="soldOutLoading">
                            {{ formData.soldOut == 2 ? '去掉售罄标志' : '添加售罄标志'}}
                        </el-button>
                    </div>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="name" label="商品名称:" :rules='[{required: true, message: "请填写商品名称"}]'>
                    <el-input v-model.trim="formData.name" placeholder="请输入商品名称" maxlength="500" size="medium"></el-input>
                </el-form-item>
                <el-form-item prop="categoryId" label="商品类别:">
                    <el-select v-model="formData.categoryId" size="medium" @change="getoperationType">
                        <el-option :value="1" label="唱片专辑"></el-option>
                        <el-option :value="2" label="服饰"></el-option>
                        <el-option :value="3" label="纪念品"></el-option>
                        <el-option :value="5" label="配饰"></el-option>
                        <!-- <el-option :value="6" label="照片"></el-option> -->
                        <el-option :value="7" label="数藏"></el-option>
                        <el-option :value="4" label="其它"></el-option>
						<el-option :value="8" label="积分商品"></el-option>
						<el-option :value="9" label="实体纪念票"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item prop="operationalCategory" :rules='[{required: true, message: "运营类别至少勾选1项"}]' label="运营类别:" >
					<el-checkbox-group v-model="formData.operationalCategory" size="medium"  v-if="operationType && operationType.length > 0 ">					    
						<span class="MR20">
						    <el-checkbox v-for="(item,index) in operationType" :key="index" :label="item.id" :checked="item.name == '热销商品' && id ==''">{{item.name}}</el-checkbox>
						</span>
					</el-checkbox-group>					
				</el-form-item>
            </el-col>
        </el-row>
		
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="priceFormat" :rules='[{required: true, message: "请填写商品价格", trigger:"blur"}]'>
                    <span slot="label">商品价格(元): 
                        <!-- <small class="color-info">0代表免费</small> -->
                    </span>
                    <el-input-number style="width:100%" v-model="formData.priceFormat" :precision="2" controls-position="right" :min="0" :max="99999999.99" size="medium" placeholder="请输入商品价格"></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="originalPriceFormat" label="商品原价(元):">
                    <el-input-number style="width:100%" v-model="formData.originalPriceFormat" :precision="2" controls-position="right" :min="0.00" :max="99999999.99" size="medium" placeholder="请输入商品原价"></el-input-number>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="limitBuyNum" :rules='[{required: true, message: "请填写限购数量"}]'>
                    <span slot="label">限购数量: <small class="color-info">0代表不限购</small></span>
                    <el-input-number style="width:100%" v-model="formData.limitBuyNum" :precision="0" controls-position="right" :min="0" :max="99999999" size="medium" placeholder="请输入限购数量" ></el-input-number>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="startDate" label="销售时间:">
                    <span slot="label">
                        销售时间：
                        <el-checkbox v-model="formData.isConfirmedStartTime" :true-label="0" :false-label="1">隐藏开售时间</el-checkbox>
                    </span>
                    <el-date-picker
						style="width: 49%;"
                        v-model="formData.startDate"
                        type="datetime"
                        placeholder="请选择开始时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="medium">
                    </el-date-picker>
					<el-date-picker
						style="width: 49%; margin-left: 10px;"
					    v-model="formData.endDate"
					    type="datetime"
					    placeholder="请选择结束时间"
					    value-format="yyyy-MM-dd HH:mm:ss"
					    size="medium">
					</el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="serviceFee" :rules='[{required: true, message: "请填写服务费率"}]'>
                    <span slot="label">服务费率(%): <small class="color-info">0-100表示0%-100%</small></span>
                    <el-input-number style="width:100%" v-model="formData.serviceFee" :precision="0" controls-position="right" :min="0" :max="100" size="medium" placeholder="请输入服务费率"></el-input-number>
                </el-form-item>
            </el-col>
			<el-col :xs="24" :sm="12" :xl="8">
			    <el-form-item prop="shipper" label="发货方:" :rules='[{required: true, message: "请选择发货方"}]'>
			        <el-select 
			            v-model="formData.shipper" 
			            filterable 
			            remote
			            placeholder="请选择发货方"
			            :remote-method="searchShipper"
			            :loading="userLoading"
			            size="medium"
			            clearable>
			            <el-option
			                v-for="item in shipperList"
			                :key="item.id"
			                :label="item.userType ? `[${$userType.get(item.userType)}]${item.name}` : `${item.name}`"
			                :value="item.id">
			            </el-option>
			        </el-select>
			    </el-form-item>
			</el-col>
            <!-- <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="serviceTemplateId" label="购买须知:">
                    <el-select v-model="formData.serviceTemplateId" size="medium">
                        <el-option v-for="(item,index) in stList" :key="index" :value="item.id" :label="item.title"></el-option>
                    </el-select>
                </el-form-item>
            </el-col> -->
        </el-row>
      <!-- <el-row :gutter="30">
           <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="type" label="商品使用场景:">
                    <el-select v-model="formData.type" size="medium" @change="changeType" :disabled="formData.id ? true : false">
                        <el-option :value="1" label="C端自用"></el-option>
                        <el-option :value="2" label="直播送礼"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            
        </el-row> -->
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item :rules='[{required: true, message: "请选择运费"}]'>
                    <span slot="label">运费: </span>					
					<el-radio-group v-model="formData.freightType" size="medium">
					    <el-radio :label="1">手动填写<el-input-number style="width:55%" v-model="formData.freightFormat" :precision="2" controls-position="right" :min="-1" :max="99999999.99" size="medium" placeholder="请输入运费" :disabled="formData.type == 2 ? true : false"  class="ML30" @change="handleChange"></el-input-number><small class="color-warning ML10 tips">0代表包邮,-1代表到付<br>支持精确到小数点后2位</small> </el-radio>						
					    <el-radio :label="2" class="MT10">绑定运费模板 
							<el-select v-model="formData.freightTemplateId" placeholder="请选择运费模板" size="small" @change="selectChange">
								<el-option v-for="(item, index) in freightList" :key="index" :label="item.name+':' + item.freightView" :value="item.id"></el-option>
							</el-select>
						</el-radio>
					</el-radio-group>					
                </el-form-item>				
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="deliveryType" label="发货方式:">
                    <el-row :gutter="10">
                        <el-col :span="formData.deliveryType != 1 ? 12 : 24">
                            <el-select v-model="formData.deliveryType" size="medium" :disabled="formData.type == 2 ? true : false">
                                <el-option :value="1" label="快递发货"></el-option>
                                <el-option :value="2" label="现场自取"></el-option>
                                <el-option :value="3" label="快递发货+现场自取"></el-option>
                            </el-select>
                        </el-col>
                        <el-col v-if="formData.deliveryType != 1" :span="12">
                            <!-- <el-select 
                                v-model="formData.deliveryUserId" 
                                filterable 
                                remote
                                placeholder="不填写小站代表平台仓库发货"
                                :remote-method="searchDeliveryUser"
                                :loading="userLoading"
                                size="medium"
                                clearable>
                                <el-option
                                    v-for="item in deliveryUser"
                                    :key="item.id"
                                    :label="item.userType ? `[${$userType.get(item.userType)}]${item.name}` : `${item.name}`"
                                    :value="item.id">
                                </el-option>
                            </el-select> -->
							<el-input v-model="formData.pickupInstruction" placeholder="说明自取时间地点等信息" size="medium" maxlength="100"></el-input>
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-col>            
        </el-row>
		<el-row :gutter="30" v-if="formData.deliveryType != 2">
		    <el-col :xs="24" :sm="12" :xl="8">
		        <el-form-item :rules='[{required: true, message: "请选择发货期限"}]'>
		            <span slot="label">发货期限: </span>					
					<el-radio-group v-model="formData.deliveryTimeType" size="medium">
					    <el-radio :label="1">现货
							<el-input-number style="width:100%" v-model="formData.deliveryTimeValue" controls-position="right" :min="1" :max="999" size="medium" placeholder="填写需要几天内发货" class="ML20" @change="handleChange2"></el-input-number></el-radio><br>						
					    <el-radio :label="2" class="MT10">预售 
							<el-date-picker
								@change="selectChange2"
								class="ML20"
							    v-model="formData.deliveryTimeValue2"
							    type="date"
							    placeholder="设置最迟发货日期"
							    value-format="yyyy-MM-dd"
							    size="medium">
							</el-date-picker>
						</el-radio>
					</el-radio-group>					
		        </el-form-item>				
		    </el-col>
		</el-row>
		<el-row :gutter="30">			
		    <el-col :xs="24" :sm="12" :xl="8">
				<el-form-item prop="canAfter" :rules='[{required: true, message: "请填写运费"}]' label="允许用户在线申请售后:">
					<el-radio-group v-model="formData.canAfter">					   
					    <el-radio :label="1">开启</el-radio>
					    <el-radio :label="0">关闭</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-col>
			<el-col :xs="24" :sm="12" :xl="8">
				<el-form-item prop="hideType" :rules='[{required: true, message: "请填写运费"}]' label="展示设置:">
					<el-radio-group v-model="formData.hideType">					   
					    <el-radio :label="0">正常展示</el-radio>
					    <el-radio :label="1">列表隐藏</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-col>
		</el-row>	
        <el-row v-if="formData.type == 2" :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="giftDescription" label="礼物说明:" :rules='[{required: true, message: "请填写礼物说明"}]'>
                    <el-input v-model="formData.giftDescription" placeholder="请输入礼物说明" size="medium"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="bigGiftDescription" label="大礼说明:">
                    <el-input v-model="formData.bigGiftDescription" placeholder="请输入大礼说明" size="medium"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :xl="16">
                <el-form-item prop="bigGiftSpecial" label="大礼特效:">
                    <SvgaUpload :url.sync="formData.bigGiftSpecial" :urlFull.sync="formData.bigGiftSpecial" ></SvgaUpload>
                </el-form-item>
            </el-col>
        </el-row>


    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import SvgaUpload from '@/components/SvgaUpload';
import {fetchUser} from '@/assets/js/commonApi';

export default {
    props:{
        formData:{
            type: Object,
            default: null
        },
		id: {
		  type: [Number, String],
		  default: null,
		}
    },
    components:{ImageUpload,SvgaUpload},
    data(){
        return{
            
            userLoading: false,
            stList:[],
            shipperList:[],
            soldOutLoading: false,			
			freightList:[],
			operationType:[]
			
        }
    },
    created(){
        this.getfreightList();		
		this.$nextTick(() => {
		    this.getoperationType(this.formData.categoryId)
		})
    },
    mounted(){
        
        if( this.formData.shipper ){
            this.shipperList = [{
                id: this.formData.shipper,
                name: this.formData.shipperName,
                userType: this.formData.shipperType
            }]
        }
		if( this.formData && this.formData.id ){
			if( this.formData && this.formData.freightTemplateId ){
				this.formData.freightType = 2
			}else{
				this.formData.freightType = 1
			}
		}else{
			this.formData.freightType = ''
		}
		
    },
    methods:{
        //选择商品使用场景
        changeType(e){
            if(e == 2){
                this.formData.freightFormat = 0;
                this.formData.deliveryType = 2;
            }
        },
        
        searchShipper(query){
            this.searchUser(query,-1,'shipperList');
        },
		handleChange(){
			this.formData.freightType = 1
		},
		selectChange(){
			this.formData.freightType = 2
		},
		handleChange2(){
			this.formData.deliveryTimeType = 1
		},
		selectChange2(){
			this.formData.deliveryTimeType = 2
		},
		// changeCategoryId(e){
		// 	var arr = this.operationType
		// 	if( e === 9 ){				
		// 		this.operationType = arr.filter(item => item.name !== '订单入口' || item.name !== '纪念票打印');			
				
		// 	}
		// },
		//获取模板列表
		getfreightList(){
		    this.listLoading = true;
		    this.$request({
		        url: '/freight/management/selectList',
		        method: 'POST',		       
		    }).then(res => {
		        const { state, msg, result } = res.data;
		        if( state == 1 && result ){		          
		            this.freightList = result || [];
					
					if( !this.formData.id ){
						var num = parseInt(result.length -1 )
						this.formData.freightTemplateId = result[num].id
					}
					
		        }else{
		            this.$message.error(msg || '请求失败');
		        }
		    }).catch(() => {
		        this.$message.error('请求错误');
		    }).finally(() => {
		        this.listLoading = false;
		    });
		},
		getoperationType(e){
			console.log(e)
		    this.$request({
		        url: '/styleTag/showType/operations/all',
		        method: 'POST',		       
		    }).then(res => {
		        const { state, msg, result } = res.data;
		        if( state == 1 && result ){		            
					if( e == 9 ){
						this.operationType = result.filter(item => item.name !== '热销商品' && item.name !== '新品速递');
					}else{						
						this.operationType = result.filter(item => item.name !== '订单入口' && item.name !== '纪念票打印');
					}
					
		        }else{
		            this.$message.error(msg || '请求失败');
		        }
		    }).catch(() => {
		        this.$message.error('请求错误');
		    })
		},
        // 搜索用户
        async searchUser(query,userType,obj){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                    userType:userType || -1,
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    this[obj] = result;
                }
            }
        },
        //获取服务模板列表
        serviceTemplate(){
            this.$request({
                url: "/service/template/list",
                data: {
					businessType: 2,
					pageNo:1,
					pageSize:100
				},
                method: "post",
            })
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1) {
                        this.stList = result.result;
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                    
                });
        },
        //预览图上传成功
        handlePosterSuccess(){
            if(this.formData.poster){
                this.formData.oldPoster = this.formData.poster;
                this.formData.soldOut = 1;
                this.$refs["formData"].clearValidate('poster');
            }
        },
        // 添加、去除海报售罄标识
        addSoldOut(){
            if( this.formData.soldOut == 1 ){
                this.soldOutLoading = true;
                this.$request({
                    url: "/activity/addSoldOut",
                    method: "POST",
                    params: {
                        activityId: this.formData.id,
                        poster: this.formData.poster
                    },
                })
                    .then((res) => {
                        //处理成功回调
                        const { state, msg, result } = res.data;
                        if (state && state == 1) {
                            this.formData.poster = result.urlFull;
                            this.formData.soldOut = 2;
                        } else {
                            return this.$message.error(msg || "操作失败");
                        }
                    })
                    .finally(() => {
                        this.soldOutLoading = false;
                    });
            }else{
                this.formData.poster = this.formData.oldPoster
                this.formData.soldOut = 1;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
	.ML30{
		margin-left:30px
	}
	.tips{
		font-size:8px;
		vertical-align: middle;
	}
</style>
